import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Truck, Trash2 } from 'lucide-react';
const problems = [{
  icon: <DollarSign className="w-6 h-6" data-id="element-388" />,
  title: 'The upfront cost',
  description: "Stocking up on bottles, crates, and pallets means writing a big check before you've sold a thing. That's cash sitting on a shelf instead of growing your business."
}, {
  icon: <Truck className="w-6 h-6" data-id="element-389" />,
  title: 'Getting it back',
  description: "Chasing down empties across hundreds of drop-offs is a full-time job. Most teams just aren't set up to run a supply chain in reverse."
}, {
  icon: <Trash2 className="w-6 h-6" data-id="element-390" />,
  title: 'Stuff goes missing',
  description: "Single-use packaging burns energy every time you make it. And even reusable packaging walks off or gets wrecked when nobody's keeping track of it."
}];
export const Problem: React.FC = () => {
  return <section className="py-24 bg-mint border-y border-primary/5" data-id="element-391">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-392">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="max-w-2xl mb-16" data-id="element-393">
          <h2 className="font-display text-4xl md:text-5xl text-primary mb-6" data-id="element-394">
            Linear packaging is broken.
          </h2>
          <p className="text-lg text-ink/70" data-id="element-395">
            Most operators end up acting like packaging buyers and logistics
            companies on the side. It's expensive, it's a hassle, and a lot of
            good material ends up in the bin.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12" data-id="element-396">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: index * 0.1
        }} className="group" data-id="element-397">
              <div className="w-12 h-12 rounded-full bg-white shadow-glossy flex items-center justify-center text-primary mb-6 group-hover:bg-leaf group-hover:text-white transition-colors duration-300" data-id="element-398">
                {problem.icon}
              </div>
              <h3 className="font-display text-2xl text-primary mb-3" data-id="element-399">
                {problem.title}
              </h3>
              <p className="text-ink/70 leading-relaxed" data-id="element-400">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};